import React from "react";
import {useSelector} from "react-redux";
import MaterialUIMultiSelect from "../../../common/selects/MaterialUIMultiSelect";
import {isMobileScreen} from "../../../../utils/displayUtils";

export default function CountriesFilter({selectedCountries, handleChangeFilterData, inputStyle}) {
    const {countries} = useSelector(state => state.filterDataReducer.filterData);
    const isMobile = isMobileScreen();

    const onSelect = (value) => {
        handleChangeFilterData("countries", value, true);
    };

    return (
            <MaterialUIMultiSelect
                styles={inputStyle}
                dropdownData={countries}
                values={selectedCountries}
                dataField='id'
                displayedField='name'
                label='Страны'
                placeholder={'-'}
                onSelect={onSelect}
                isSearchable={!isMobile}
            />
    );
}